import axios from 'axios'
import store from "@/store";

function getbaseUrl () {
  if (
    window.__APP_CONFIG__.VUE_APP_MULTI_DATABASE === "true" ||
    window.__APP_CONFIG__.VUE_APP_MULTIPLAS_BASE_URL === "true"
  ) {
    return localStorage.baseUrl || window.__APP_CONFIG__.VUE_APP_URL_BASE
  }

  return window.__APP_CONFIG__.VUE_APP_URL_BASE
}

const instancia = axios.create({
  baseURL: `${getbaseUrl()}/api`
});

function getHeaders() {
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Accept: "application/json"
  };

  if (localStorage.token) {
    headers.Authorization = `Bearer ${localStorage.token}`;
  }

  return headers;
}

function onRequest(config) {
  store.dispatch('loading/incrementarQtdeRequisicoes');

  config.headers = {
    ...config.headers,
    ...getHeaders()
  }

  return config;
}

function onResponse(response) {
  store.dispatch('loading/decrementarQtdeRequisicoes');

  if (response.data.token) {
    localStorage.setItem('token', response.data.token);
  }

  return response;
}

function onRejected(error) {
  setTimeout(() => store.dispatch('loading/decrementarQtdeRequisicoes'), 50);

  if (error.response.data.token) {
    localStorage.setItem('token', error.response.data.token);
  }

  return Promise.reject(error);
}

instancia.interceptors.request.use(onRequest);
instancia.interceptors.response.use(onResponse, onRejected);

export default instancia
